import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { listenToCelebrityHomeImages } from "../../services/celebrityDesignService";

export default function CelebrityDesignCarousel() {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => listenToCelebrityHomeImages(setImages, () => setImages([])), []);
  useEffect(() => {
    if (images.length < 2) return undefined;
    const timer = window.setInterval(() => setIndex((value) => (value + 1) % images.length), 3000);
    return () => window.clearInterval(timer);
  }, [images]);

  return <section className="py-8 md:py-12 bg-[#FFF8F2]">
    <button type="button" onClick={() => navigate("/celebrity-designs")} className="relative block w-full max-w-[1120px] aspect-[20/8] max-h-[360px] mx-auto overflow-hidden rounded-[20px] text-left group bg-[#2B2522] shadow-lg">
      {images.length ? images.map((image, imageIndex) => <img key={image} src={image} alt="Celebrity design inspiration" className={`absolute inset-0 w-full h-full object-contain object-center transition-opacity duration-700 ${imageIndex === index % images.length ? "opacity-100" : "opacity-0"}`} />) : null}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
      <div className="absolute left-6 right-6 md:left-14 md:right-14 bottom-8 md:bottom-12 text-white">
        <div className="font-label text-[#FFB184] mb-3">New inspiration</div>
        <div className="flex items-end justify-between gap-6"><div><h2 className="font-display text-4xl md:text-6xl">Celebrity Designs</h2><p className="mt-3 text-white/90">Explore the latest looks and request your tailor quotation.</p></div><span className="w-12 h-12 rounded-full bg-white text-[#2B2522] flex items-center justify-center group-hover:bg-[#F46524] group-hover:text-white transition-colors"><ArrowRight /></span></div>
      </div>
    </button>
  </section>;
}
